export default __webpack_public_path__ + "static/media/510.d1921ba5.png";